var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_2137_7543)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3879 26.1943C26.8811 26.1943 28.9022 24.1732 28.9022 21.6801C28.9022 19.1869 26.8811 17.1658 24.3879 17.1658C21.8948 17.1658 19.8737 19.1869 19.8737 21.6801C19.8737 24.1732 21.8948 26.1943 24.3879 26.1943ZM24.3879 28.0001C19.4016 28.0001 15.3594 32.0423 15.3594 37.0286V37.9315C15.3594 38.43 15.7636 38.8343 16.2622 38.8343H32.5137C33.0123 38.8343 33.4165 38.43 33.4165 37.9315V37.0286C33.4165 32.0423 29.3743 28.0001 24.3879 28.0001ZM39.7365 38.8343H35.5427C35.6278 38.5483 35.6737 38.2451 35.6737 37.9315V37.0286C35.6737 33.343 33.907 30.0701 31.1742 28.0104C31.3188 28.0035 31.4644 28.0001 31.6107 28.0001C36.5971 28.0001 40.6394 32.0423 40.6394 37.0286V37.9315C40.6394 38.43 40.2351 38.8343 39.7365 38.8343ZM31.6107 26.1943C30.9522 26.1943 30.3265 26.0533 29.7623 25.7998C30.6385 24.6585 31.1593 23.2301 31.1593 21.6801C31.1593 20.13 30.6385 18.7016 29.7623 17.5603C30.3265 17.3068 30.9522 17.1658 31.6107 17.1658C34.104 17.1658 36.1251 19.1869 36.1251 21.6801C36.1251 24.1732 34.104 26.1943 31.6107 26.1943Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_7543",
    x1: -6.00482,
    y1: 61.32,
    x2: 67.2446,
    y2: 57.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57249C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB3366"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAccounts);
export default __webpack_public_path__ + "static/media/sub_accounts.c91cba6d8c17c96c251ac7957ca86eb0.svg";
export { ForwardRef as ReactComponent };